import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableEquipmentIssued extends Layout {
    sourceEquipmentIssued: DataSource;
    tableEquipmentIssued: Table;
}
